<template>
  <table class="table table-details">
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-emv-clearing', params: {id: details.account_id, resource_id: details.id}}">
          {{ details.id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.tenant_operator') }}</label></td>
      <td>{{ details.tenant_operator }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.account_id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-emv-clearings', params: {id: details.account_id}}">
          {{ details.account_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.card_token') }}</label></td>
      <td>{{ details.card_token }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.business_day') }}</label></td>
      <td>{{ details.business_day | dateOnly }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.amount') }}</label></td>
      <td>{{ details.amount | money }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.payment_reference') }}</label></td>
      <td>{{ details.payment_reference }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.clearing_result') }}</label></td>
      <td>{{ details.clearing_result }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.cr_updated_at') }}</label></td>
      <td>{{ details.cr_updated_at | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.payment_result') }}</label></td>
      <td>{{ details.payment_result }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.pr_business_day') }}</label></td>
      <td>{{ details.pr_business_day | dateOnly }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.pr_updated_at') }}</label></td>
      <td>{{ details.pr_updated_at | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.pr_additional_info') }}</label></td>
      <td>
        <meta-data-details :data="details.pr_additional_info" />
      </td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.par') }}</label></td>
      <td>{{ details.par }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.emv_cut_over_id') }}</label></td>
      <td>
        <router-link v-if="details.emv_cut_over_id"
                     :to="{name: 'emvCutOver', params: {id: details.emv_cut_over_id}}">
          {{ details.emv_cut_over_id }}
        </router-link>
      </td>
    </tr>
    <tr v-if="details.emv_clearing_entries">
      <td class="text-nowrap"><label>{{ $t('emvClearings.details.emv_clearing_entries') }}</label></td>
      <td>
        <emv-clearing-entries-table :details-arr="details.emv_clearing_entries ? details.emv_clearing_entries:[]"/>
      </td>
    </tr>
  </table>
</template>
<script>
import EmvClearingEntriesTable from "@/components/EmvClearingEntry/EmvClearingEntriesTable";
import MetaDataDetails from "src/components/MetaData/MetaDataDetails";

export default {
  name: 'EmvClearingDetails',
  components: {
    EmvClearingEntriesTable,
    MetaDataDetails
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
